import * as React from "react";

import { LoadingIndicator as LoadingIndicatorAtom } from "@ui/Atoms";

const LoadingIndicator = () => {
  // @TODO uncomment when redux is configured
  // const show: boolean = useSelector(getLoadingState);
  const show = false;

  return <LoadingIndicatorAtom show={show} />;
};

export { LoadingIndicator };

LoadingIndicator.displayName = "LoadingIndicator";
